import { downloadBankAverageCost } from '../bank/averageCost/store/thunk'
import { downloadBankBalanceBreakdown } from '../bank/balanceBreakdown/store/thunk'
import { downloadBankCapitalAndLeverage } from '../bank/capitalAndLeverage/store/thunk'
import { downloadBankCashBreakdown } from '../bank/cashFlow/store/thunk'
import { downloadBankDepositAndCredit } from '../bank/depositAndCredit/store/thunk'
import { downloadBankEarningBreakdown } from '../bank/earningBreakdown/store/thunk'
import { downloadBankEarningsQuality } from '../bank/earningQuality/store/thunk'
import { downloadBankFundingStructure } from '../bank/fundingStructure/store/thunk'
import { downloadBankLiquidity } from '../bank/liquidity/store/thunk'
import { downloadBankLoanBookBreakdown } from '../bank/loanBookBreakdown/store/thunk'
import { downloadBankQuickAssessment } from '../bank/quickAssessment/store/thunk'
import {
  typeComponentBank,
  typeComponentCorporate,
  typeComponentLifeInsurance,
  typeComponentNonBank,
  typeComponentNonLifeInsurance,
  typeComponentSecurity,
} from '../constant'
import { downloadAssetManagementEfficiencyThunk } from '../corporate/assetManagementEfficiency/store/thunk'
import { downloadCorpBalanceBreakdown } from '../corporate/balanceBreakdown/store/thunk'
import { downloadCorpCashBreakdown } from '../corporate/cashBreakdown/store/thunk'
import { downloadCorpCoverage } from '../corporate/coverage/store/thunk'
import { downloadCorpEarningBreakdown } from '../corporate/earningBreakdown/store/thunk'
import { downloadCorpLiquidity } from '../corporate/liquidity/store/thunk'
import { downloadProfitabilityThunk } from '../corporate/profitability/store/thunk'
import { downloadQuickAssessmentCorporateThunk } from '../corporate/quickAssessment/store/thunk'
import { downloadRoaAndRoeThunk } from '../corporate/roaAndRoe/store/thunk'
import { downloadCorpSolvency } from '../corporate/solvency/store/thunk'
import { downloadLifeInsBalanceBreakdown } from '../lifeInsurance/balanceBreakdown/store/thunk'
import { downloadLifeInsCashBreakdown } from '../lifeInsurance/cashFlow/store/thunk'
import { downloadLifeInsEarningBreakdown } from '../lifeInsurance/earningBreakdown/store/thunk'
import { downloadLifeInsInsurancePremiumRevenue } from '../lifeInsurance/insurancePremiumRevenue/store/thunk'
import { downloadLifeInsInsuranceSolvency } from '../lifeInsurance/insuranceSolvency/store/thunk'
import { downloadLifeInsLiquidity } from '../lifeInsurance/liquidity/store/thunk'
import { downloadLifeInsOperationalEfficiency } from '../lifeInsurance/operationalEfficiency/store/thunk'
import { downloadLifeInsProfitabilityThunk } from '../lifeInsurance/profitability/store/thunk'
import { downloadLifeInsRoaAndRoeThunk } from '../lifeInsurance/roaAndRoe/store/thunk'
import { downloadNonBankAverageCost } from '../nonBank/averageCost/store/thunk'
import { downloadNonBankBalanceBreakdown } from '../nonBank/balanceBreakdown/store/thunk'
import { downloadNonBankCapitalAndLeverage } from '../nonBank/capitalAndLeverage/store/thunk'
import { downloadNonBankCashBreakdown } from '../nonBank/cashFlow/store/thunk'
import { downloadNonBankDepositAndCredit } from '../nonBank/depositAndCredit/store/thunk'
import { downloadNonBankEarningBreakdown } from '../nonBank/earningBreakdown/store/thunk'
import { downloadNonBankEarningsQuality } from '../nonBank/earningQuality/store/thunk'
import { downloadNonBankFundingStructure } from '../nonBank/fundingStructure/store/thunk'
import { downloadNonBankLiquidity } from '../nonBank/liquidity/store/thunk'
import { downloadNonBankLoanBookBreakdown } from '../nonBank/loanBookBreakdown/store/thunk'
import { downloadNonBankQuickAssessment } from '../nonBank/quickAssessment/store/thunk'
import { downloadNonLifeInsBalanceBreakdown } from '../nonLifeInsurance/balanceBreakdown/store/thunk'
import { downloadNonLifeInsCashBreakdown } from '../nonLifeInsurance/cashFlow/store/thunk'
import { downloadNonLifeInsEarningBreakdown } from '../nonLifeInsurance/earningBreakdown/store/thunk'
import { downloadNonLifeInsInsurancePremiumRevenue } from '../nonLifeInsurance/insurancePremiumRevenue/store/thunk'
import { downloadNonLifeInsInsuranceSolvency } from '../nonLifeInsurance/insuranceSolvency/store/thunk'
import { downloadNonLifeInsLiquidity } from '../nonLifeInsurance/liquidity/store/thunk'
import { downloadNonLifeInsOperationalEfficiency } from '../nonLifeInsurance/operationalEfficiency/store/thunk'
import { downloadNonLifeInsProfitabilityThunk } from '../nonLifeInsurance/profitability/store/thunk'
import { downloadNonLifeInsRoaAndRoeThunk } from '../nonLifeInsurance/roaAndRoe/store/thunk'
import { downloadSecuBalanceBreakdown } from '../security/balanceBreakdown/store/thunk'
import { downloadSecuBusinessPosition } from '../security/businessPosition/store/thunk'
import { downloadSecuCashBreakdown } from '../security/cashFlow/store/thunk'
import { downloadSecuEarningBreakdown } from '../security/earningBreakdown/store/thunk'
import { downloadSecuEarningQuality } from '../security/earningQuality/store/thunk'
import { downloadFinancialAssets } from '../security/financialAsset/store/thunk'
import { downloadSecuFundingAndLiquidity } from '../security/fundingAndLiquidity/store/thunk'
import { downloadLeverage } from '../security/leverage/store/thunk'
import { downloadSecuOperatingIncome } from '../security/operatingIncome/store/thunk'

const getActionDownload = (type) => {
  switch (type) {
    // corporate
    case typeComponentCorporate.QUICK_ASSESSMENT:
      return downloadQuickAssessmentCorporateThunk
    case typeComponentCorporate.PROFITABILITY:
      return downloadProfitabilityThunk
    case typeComponentCorporate.ROA_AND_ROE:
      return downloadRoaAndRoeThunk
    case typeComponentCorporate.ASSET_MANAGEMENT_EFFICIENCY:
      return downloadAssetManagementEfficiencyThunk
    case typeComponentCorporate.LIQUIDITY:
      return downloadCorpLiquidity
    case typeComponentCorporate.SOLVENCY:
      return downloadCorpSolvency
    case typeComponentCorporate.COVERAGE:
      return downloadCorpCoverage
    case typeComponentCorporate.EARNING_BREAKDOWN:
      return downloadCorpEarningBreakdown
    case typeComponentCorporate.BALANCE_BREAKDOWN:
      return downloadCorpBalanceBreakdown
    case typeComponentCorporate.CASH_BREAKDOWN:
      return downloadCorpCashBreakdown
    // bank
    case typeComponentBank.QUICK_ASSESSMENT:
      return downloadBankQuickAssessment
    case typeComponentBank.LOAN_BOOK_BREAKDOWN:
      return downloadBankLoanBookBreakdown
    case typeComponentBank.DEPOSIT_AND_CREDIT:
      return downloadBankDepositAndCredit
    case typeComponentBank.AVERAGE_COST:
      return downloadBankAverageCost
    case typeComponentBank.EARNING_QUALITY:
      return downloadBankEarningsQuality
    case typeComponentBank.CAPITAL_AND_LEVERAGE:
      return downloadBankCapitalAndLeverage
    case typeComponentBank.LIQUIDITY:
      return downloadBankLiquidity
    case typeComponentBank.FUNDING_STRUCTURE:
      return downloadBankFundingStructure
    case typeComponentBank.BALANCE_BREAKDOWN:
      return downloadBankBalanceBreakdown
    case typeComponentBank.EARNING_BREAKDOWN:
      return downloadBankEarningBreakdown
    case typeComponentBank.CASH_FLOW:
      return downloadBankCashBreakdown
    // non bank
    case typeComponentNonBank.QUICK_ASSESSMENT:
      return downloadNonBankQuickAssessment
    case typeComponentNonBank.LOAN_BOOK_BREAKDOWN:
      return downloadNonBankLoanBookBreakdown
    case typeComponentNonBank.DEPOSIT_AND_CREDIT:
      return downloadNonBankDepositAndCredit
    case typeComponentNonBank.AVERAGE_COST:
      return downloadNonBankAverageCost
    case typeComponentNonBank.EARNING_QUALITY:
      return downloadNonBankEarningsQuality
    case typeComponentNonBank.CAPITAL_AND_LEVERAGE:
      return downloadNonBankCapitalAndLeverage
    case typeComponentNonBank.LIQUIDITY:
      return downloadNonBankLiquidity
    case typeComponentNonBank.FUNDING_STRUCTURE:
      return downloadNonBankFundingStructure
    case typeComponentNonBank.BALANCE_BREAKDOWN:
      return downloadNonBankBalanceBreakdown
    case typeComponentNonBank.EARNING_BREAKDOWN:
      return downloadNonBankEarningBreakdown
    case typeComponentNonBank.CASH_FLOW:
      return downloadNonBankCashBreakdown
    // security
    case typeComponentSecurity.OPERATING_INCOME:
      return downloadSecuOperatingIncome
    case typeComponentSecurity.BUSINESS_POSITION:
      return downloadSecuBusinessPosition
    case typeComponentSecurity.FINANCIAL_ASSET:
      return downloadFinancialAssets
    case typeComponentSecurity.EARNING_QUALITY:
      return downloadSecuEarningQuality
    case typeComponentSecurity.LEVERAGE:
      return downloadLeverage
    case typeComponentSecurity.FUNDING_AND_LIQUIDITY:
      return downloadSecuFundingAndLiquidity
    case typeComponentSecurity.EARNING_BREAKDOWN:
      return downloadSecuEarningBreakdown
    case typeComponentSecurity.BALANCE_BREAKDOWN:
      return downloadSecuBalanceBreakdown
    case typeComponentSecurity.CASH_FLOW:
      return downloadSecuCashBreakdown
    // life insurance
    case typeComponentLifeInsurance.BALANCE_BREAKDOWN:
      return downloadLifeInsBalanceBreakdown
    case typeComponentLifeInsurance.CASH_FLOW:
      return downloadLifeInsCashBreakdown
    case typeComponentLifeInsurance.EARNING_BREAKDOWN:
      return downloadLifeInsEarningBreakdown
    case typeComponentLifeInsurance.INSURANCE_PREMIUM_REVENUE:
      return downloadLifeInsInsurancePremiumRevenue
    case typeComponentLifeInsurance.INSURANCE_SOLVENCY:
      return downloadLifeInsInsuranceSolvency
    case typeComponentLifeInsurance.LIQUIDITY:
      return downloadLifeInsLiquidity
    case typeComponentLifeInsurance.OPERATIONAL_EFFICIENCY:
      return downloadLifeInsOperationalEfficiency
    case typeComponentLifeInsurance.PROFITABILITY:
      return downloadLifeInsProfitabilityThunk
    case typeComponentLifeInsurance.ROA_AND_ROE:
      return downloadLifeInsRoaAndRoeThunk
    // non life insurance
    case typeComponentNonLifeInsurance.BALANCE_BREAKDOWN:
      return downloadNonLifeInsBalanceBreakdown
    case typeComponentNonLifeInsurance.CASH_FLOW:
      return downloadNonLifeInsCashBreakdown
    case typeComponentNonLifeInsurance.EARNING_BREAKDOWN:
      return downloadNonLifeInsEarningBreakdown
    case typeComponentNonLifeInsurance.INSURANCE_PREMIUM_REVENUE:
      return downloadNonLifeInsInsurancePremiumRevenue
    case typeComponentNonLifeInsurance.INSURANCE_SOLVENCY:
      return downloadNonLifeInsInsuranceSolvency
    case typeComponentNonLifeInsurance.LIQUIDITY:
      return downloadNonLifeInsLiquidity
    case typeComponentNonLifeInsurance.OPERATIONAL_EFFICIENCY:
      return downloadNonLifeInsOperationalEfficiency
    case typeComponentNonLifeInsurance.PROFITABILITY:
      return downloadNonLifeInsProfitabilityThunk
    case typeComponentNonLifeInsurance.ROA_AND_ROE:
      return downloadNonLifeInsRoaAndRoeThunk
    default:
      return
  }
}

export default getActionDownload
